import { Pipe, PipeTransform } from '@angular/core';
import { stripTags } from 'src/app/core/utils/dom-utils';

@Pipe({
  name: 'stripTags',
  standalone: false,
})
export class StripTagsPipe implements PipeTransform {
  public transform(str?: string): string {
    return stripTags(str);
  }
}
